import { linkWhatsApp, perguntas } from '../data/conteudo';
import styles from './Duvidas.module.css';

const Duvidas = () => (
  <section id="duvidas" className="secao secao-rosada" aria-labelledby="titulo-duvidas">
    <div className={`container ${styles.grade}`}>
      <div className={styles.topo}>
        <h2 id="titulo-duvidas">Dúvidas frequentes</h2>
        <p>
          Não encontrou o que procurava?{' '}
          <a href={linkWhatsApp} target="_blank" rel="noopener noreferrer">
            Envie sua pergunta pelo WhatsApp
          </a>
          .
        </p>
      </div>

      <div className={styles.lista}>
        {perguntas.map((item, indice) => (
          <details key={item.pergunta} className={styles.item} open={indice === 0}>
            <summary>
              <span>{item.pergunta}</span>
              <span className={styles.sinal} aria-hidden="true" />
            </summary>
            <p>{item.resposta}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);

export default Duvidas;
